var _PoweredBy, _Skeleton;
import { Skeleton } from '@crehana/compass.ui/v2';
import CrehanaIso from '@crehana/icons/logos/CrehanaIso';
import { neutralDark, neutralLight } from '@crehana/tailwindcss';
import { clsx } from 'clsx';
import { useSidebar } from "../../../sidebar-context";
import { MenuLink } from "../menu-link";
import { PoweredBy } from "../powered-by";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var Footer = function Footer() {
  var _useSidebar = useSidebar(),
    isDark = _useSidebar.isDark,
    sidebarCollapsed = _useSidebar.sidebarCollapsed,
    footerLinks = _useSidebar.footerLinks,
    _onClickItem = _useSidebar.onClickItem,
    isLoading = _useSidebar.isLoading,
    onClickModule = _useSidebar.onClickModule;
  var borderColor = 'tw-border-neutral-light-300 dark:tw-border-elevation-dark-03';
  var currentIconColor = isDark ? neutralDark[600] : neutralLight[700];
  var currentLogo = sidebarCollapsed ? /*#__PURE__*/_jsx(CrehanaIso, {
    size: 12,
    color: currentIconColor
  }) : _PoweredBy || (_PoweredBy = /*#__PURE__*/_jsx(PoweredBy, {}));
  return /*#__PURE__*/_jsxs("footer", {
    className: clsx('tw-w-full tw-mt-auto tw-border-solid tw-border-t', borderColor, {
      'tw-flex tw-flex-col tw-items-center': sidebarCollapsed
    }),
    children: [/*#__PURE__*/_jsx("ul", {
      className: "tw-w-ful tw-pl-1.2 tw-pr-0.8",
      children: isLoading ? _Skeleton || (_Skeleton = /*#__PURE__*/_jsx(Skeleton, {
        className: "tw-w-full tw-h-4 tw-my-0.8 tw-rounded-0.8"
      })) : /*#__PURE__*/_jsx(_Fragment, {
        children: footerLinks === null || footerLinks === void 0 ? void 0 : footerLinks.map(function (link) {
          return /*#__PURE__*/_jsx(MenuLink, {
            menuLink: link,
            isFooterLink: true,
            onClickItem: function onClickItem() {
              // biome-ignore lint/style/useBlockStatements: single-line early return
              if (_onClickItem && link.url) _onClickItem(link.url, link.openInNewTab);
            },
            onClickModule: onClickModule
          }, link.code);
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: clsx("tw-flex tw-items-center tw-py-1.2 tw-px-2 tw-border-solid tw-border-t tw-w-full", borderColor, {
        'tw-flex-col tw-items-center': sidebarCollapsed
      }),
      children: currentLogo
    })]
  });
};